import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { pointsSelector } from "../../slice";
import GoogleMapRoute from "./GoogleMapRoute";
import { fetchTripCoordinates, fetchTripPoints, fetchTripSnapToRoadCoordinates } from "../../api";

export default function TripRoute({
    trip,
    isRouteEnhanced,
    handleRouteEnhancingStarting,
    routeEnhancementSuccessCallback,
}) {
    const [tripData, setTripData] = useState({
        coordinates: [],
        pickupPoint: null,
        dropoffs: [],
    });
    const [activeMarker, setActiveMarker] = useState(null);
    const tripPoints = useSelector(pointsSelector());

    const getTripCoordinates = () => {
        fetchTripCoordinates(trip?.id).then((res) => {
            const coordinates = res?.entities?.trips[`_${trip?.id}`].attributes?.coordinates;
            setTripData((prev) => ({
                ...prev,
                coordinates: coordinates?.map((item) => ({
                    lat: +item[1],
                    lng: +item[0],
                })),
            }));
        });
    };

    const getTripSnapToRoadsCoordinates = () => {
        handleRouteEnhancingStarting(true);
        fetchTripSnapToRoadCoordinates(trip?.id).then((res) => {
            const coordinates =
                res?.entities?.trips[`_${trip?.id}`].attributes?.snapToRoadsCoordinates;
            // debugger;
            setTripData((prev) => ({
                ...prev,
                coordinates: coordinates?.map((item) => ({
                    lat: +item[1],
                    lng: +item[0],
                })),
            }));
            routeEnhancementSuccessCallback();
        });
    };

    const getTripPoints = () => {
        fetchTripPoints(trip?.id).then((res) => {
            const points = Object.values(res?.entities?.tripLogs || {});
            const pickupPointData = tripPoints?.filter(
                (point) => point?.id === points[0]?.attributes?.currentTripPointId
            )[0];
            const locationAttributes = pickupPointData?.locationAttributes?.data?.attributes || {};
            const {
                name: pickupPointName,
                nameAr: pickupPointNameAr,
                nameEn: pickupPointNameEn,
            } = locationAttributes;
            setTripData((prev) => ({
                ...prev,
                pickupPoint:
                    points.length > 0
                        ? {
                              lat: +(points[0]?.attributes?.latitude || 0),
                              lng: +(points[0]?.attributes?.longitude || 0),
                              address: points[0].attributes?.address,
                              loggedAt: points[0].attributes?.loggedAt,
                              name: pickupPointName,
                              nameAr: pickupPointNameAr,
                              nameEn: pickupPointNameEn,
                              index: 0,
                          }
                        : null,
                dropoffs: points
                    ?.filter(
                        (point, index) => index !== 0 && point.attributes?.logType === "Trip point"
                    )
                    .map((item, index) => {
                        const pointData = tripPoints.filter(
                            (tripPoint) => tripPoint.id === item.attributes?.currentTripPointId
                        )[0];
                        const { name, nameAr, nameEn } =
                            pointData?.locationAttributes?.data?.attributes ?? {};
                        return {
                            lat: +(item?.attributes?.latitude || 0),
                            lng: +(item?.attributes?.longitude || 0),
                            address: item.attributes?.address,
                            loggedAt: item.attributes?.loggedAt,
                            name,
                            nameAr,
                            nameEn,
                            index: index + 1,
                        };
                    }),
                waitingPoints: points
                    ?.filter((point) => point.attributes?.logType === "Waiting point")
                    .map((item, index) => ({
                        lat: +(item?.attributes?.latitude || 0),
                        lng: +(item?.attributes?.longitude || 0),
                        address: item.attributes?.address,
                        loggedAt: item.attributes?.loggedAt,
                        waitingTime: item.attributes?.waitingMinutes,
                        index: index + 1,
                    })),
                lowBatteryPoints: points
                    ?.filter(
                        (point) =>
                            point.attributes?.logType === "Error" &&
                            point.attributes?.errorType === "Dying battery"
                    )
                    .map((item, index) => ({
                        lat: +(item?.attributes?.latitude || 0),
                        lng: +(item?.attributes?.longitude || 0),
                        address: item.attributes?.address,
                        loggedAt: item.attributes?.loggedAt,
                        waitingTime: item.attributes?.waitingMinutes,
                        batteryLevel: +(item.attributes?.device?.batteryLevel || 0) * 100,
                        index: index + 1,
                    })),
                deadBatteryPoints: points
                    ?.filter(
                        (point) =>
                            point.attributes?.logType === "Error" &&
                            point.attributes?.errorType === "Dead battery"
                    )
                    .map((item, index) => ({
                        lat: +(item?.attributes?.latitude || 0),
                        lng: +(item?.attributes?.longitude || 0),
                        address: item.attributes?.address,
                        loggedAt: item.attributes?.loggedAt,
                        waitingTime: item.attributes?.waitingMinutes,
                        batteryLevel: +(item.attributes?.device?.batteryLevel || 0) * 100,
                        index: index + 1,
                    })),
            }));
        });
    };

    useEffect(() => {
        if (trip.status !== "pending") {
            // getTripCoordinates();
            if (isRouteEnhanced) {
                getTripSnapToRoadsCoordinates();
            } else {
                getTripCoordinates();
            }
            getTripPoints();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isRouteEnhanced]);

    const handleActiveMarker = (point) => {
        if (point) {
            setActiveMarker(activeMarker === point ? null : point);
        } else {
            setActiveMarker(null);
        }
    };

    return (
        <GoogleMapRoute
            containerElement={{ height: "500px" }}
            isOpen
            tripData={tripData}
            activeMarker={activeMarker}
            handleActiveMarker={handleActiveMarker}
            tripStatus={trip?.status}
            trip={trip}
        />
    );
}
